import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect,ModelSelect} from 'vue-search-select';

export default {
  name: 'push-Bagin-Rule',
  components: {
    VueElementLoading,
    BasicSelect,
    ModelSelect
  },
  props: [],
  data () {
    return {
      isLoading: false,
      hubLoading:'',
      hubid: "",
      DestHubNameData: [],
      HubNameData: [],
      isUnbox:false,
      ClientID:'',
    }
  },
  computed: {},

  filters: {
  },
  mounted () {
    this.getHubName();
  },
  methods: {

    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },

    pushClientIdDetails() {
      this.isLoading = true
      this.ClientID=parseInt(this.ClientID);
      this.input = ({
        clientId:this.ClientID,
        hubId:this.hubid,
        isUnbox:this.isUnbox
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'pushClientIdDetails',
          'data': this.input,
          headers: {
            'authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("failed")
          console.error(error)
          this.isLoading = false
        })
    },

    onSubmit: function(scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.pushClientIdDetails();
					}
				}).catch((err) => {
					console.log('errors exist', this.errors);
				});
		},

    resetForm() {
      this.hubid='';
      this.isUnbox=false,
      this.ClientID='';
      this.$validator.reset()
		},
  }
}



// WEBPACK FOOTER //
// ./src/views/components/PushBaginRule/PushBaginRule.js